// Delegated so it survives the section re-rendering in the theme editor.
document.addEventListener('click', (event) => {
  const shield = event.target.closest?.('.cdf__map-shield');
  if (!shield) return;

  const plate = shield.closest('.cdf__map-plate');
  if (!plate) return;

  plate.dataset.mapActive = 'true';

  const frame = plate.querySelector('.cdf__map-frame');
  if (frame) frame.focus?.();
});
